import React, { type ReactNode } from 'react';
import { dataTableClass, dataTableScrollClass, dataTableShellClass } from './styles.ts';

export type DataTableShellProps = {
  children: ReactNode;
  /** Extra classes on outer card wrapper */
  className?: string;
};

export const DataTableShell = ({ children, className }: DataTableShellProps): React.ReactElement => {
  const shellClass = className ? `${dataTableShellClass} ${className}` : dataTableShellClass;

  return (
    <div className={shellClass}>
      <div className={dataTableScrollClass}>
        <table className={dataTableClass}>{children}</table>
      </div>
    </div>
  );
};
